/**
 * Stacks event detail sections with hairline separators, like the prototype.
 * Absent sections are filtered out by the caller, so a missing block never
 * leaves a stray divider behind.
 */
function DetailSections({ sections }) {
  return (
    <div className="flex flex-col">
      {sections.map((section, index) => (
        <div
          key={section.key}
          className={[
            index > 0 ? 'border-t border-edge pt-5' : '',
            index < sections.length - 1 ? 'pb-5' : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {section}
        </div>
      ))}
    </div>
  );
}

export default DetailSections;
